/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompanyOverviewDto } from './CompanyOverviewDto';
import {
    CompanyOverviewDtoFromJSON,
    CompanyOverviewDtoFromJSONTyped,
    CompanyOverviewDtoToJSON,
    CompanyOverviewDtoToJSONTyped,
} from './CompanyOverviewDto';

/**
 * 
 * @export
 * @interface CompanyOverviewDtoPagedResponseDto
 */
export interface CompanyOverviewDtoPagedResponseDto {
    /**
     * 
     * @type {Array<CompanyOverviewDto>}
     * @memberof CompanyOverviewDtoPagedResponseDto
     */
    items?: Array<CompanyOverviewDto> | null;
    /**
     * 
     * @type {number}
     * @memberof CompanyOverviewDtoPagedResponseDto
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyOverviewDtoPagedResponseDto
     */
    pageIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof CompanyOverviewDtoPagedResponseDto
     */
    pageSize?: number;
}

/**
 * Check if a given object implements the CompanyOverviewDtoPagedResponseDto interface.
 */
export function instanceOfCompanyOverviewDtoPagedResponseDto(value: object): value is CompanyOverviewDtoPagedResponseDto {
    return true;
}

export function CompanyOverviewDtoPagedResponseDtoFromJSON(json: any): CompanyOverviewDtoPagedResponseDto {
    return CompanyOverviewDtoPagedResponseDtoFromJSONTyped(json, false);
}

export function CompanyOverviewDtoPagedResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompanyOverviewDtoPagedResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(CompanyOverviewDtoFromJSON)),
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'pageIndex': json['pageIndex'] == null ? undefined : json['pageIndex'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
    };
}

export function CompanyOverviewDtoPagedResponseDtoToJSON(json: any): CompanyOverviewDtoPagedResponseDto {
    return CompanyOverviewDtoPagedResponseDtoToJSONTyped(json, false);
}

export function CompanyOverviewDtoPagedResponseDtoToJSONTyped(value?: CompanyOverviewDtoPagedResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(CompanyOverviewDtoToJSON)),
        'totalCount': value['totalCount'],
        'pageIndex': value['pageIndex'],
        'pageSize': value['pageSize'],
    };
}

